import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import MantenimientosTable from './shared/MantenimientosTable';
import MantenimientoSlideOver from './MantenimientoSlideOver';
import { categorizar } from './shared/useFlota';
import { fmtMoney } from './shared/format';

export default function HistoricoPage() {
  const { mantenimientos, isLoading, refetch } = useOutletContext();
  const [detalleId, setDetalleId] = useState(null);

  const rows = useMemo(() => {
    const c = categorizar(mantenimientos).completados;
    return c.sort((a, b) => (b.fecha_realizada || '').localeCompare(a.fecha_realizada || ''));
  }, [mantenimientos]);

  const totalCosto = useMemo(
    () => rows.reduce((acc, r) => acc + Number(r.costo || 0), 0),
    [rows]
  );

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Histórico de mantenimientos</Typography>
          <Typography sx={{ fontSize: 12, color: '#64748b' }}>
            {rows.length} tarea(s) completadas (solo lectura).
          </Typography>
        </Box>
        {totalCosto > 0 && (
          <Paper sx={{ px: 2, py: 1, bgcolor: '#f0fdfa', border: '1px solid #99f6e4', borderRadius: 2 }}>
            <Typography sx={{ fontSize: 10, color: '#0d9488', fontWeight: 700, textTransform: 'uppercase' }}>
              Costo total
            </Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#0d9488' }}>{fmtMoney(totalCosto)}</Typography>
          </Paper>
        )}
      </Box>

      <MantenimientosTable rows={rows} loading={isLoading}
        onRowClick={r => setDetalleId(r.id)}
        showProveedor showCosto
        defaultSortBy="fecha_realizada" defaultSortDir="desc"
        emptyTitle="Sin histórico"
        emptyMessage="Cuando completes un mantenimiento, aparecerá aquí." />

      {detalleId && (
        <MantenimientoSlideOver mantenimientoId={detalleId}
          onClose={() => setDetalleId(null)} onUpdated={refetch} />
      )}
    </Box>
  );
}
